import { render, staticRenderFns } from "./planosBimestraisInfantil.vue?vue&type=template&id=f3860e22"
import script from "./planosBimestraisInfantil.vue?vue&type=script&lang=js"
export * from "./planosBimestraisInfantil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports